import { useCallback, useEffect, useState } from 'react';
import { OrganisationService } from '../../services/company/organisationService';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage company fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de compañias.
----------------------------------------------------------------------------------------*/

const useCompanies = () => {
    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchCompanies = useCallback(async (companyId?: string) => {
        try {
            if (!userCan('list', 'companies')) return;
            const service = new OrganisationService();
            const response = await service.listSelectCompany({ limit: 999999 });
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching companies:', error);
        }
    }, []);

    useEffect(() => {
        fetchCompanies();
    }, []);

    const getCompaniesList = () => {
        return data;
    };

    return { fetchCompanies, getCompaniesList };
}

export default useCompanies;